import styled from '@emotion/styled';
import Button from '@portalterreno/react-ui-core/Button';

const CloseButton = styled(Button)({
  width: '50%'
});

export default CloseButton;
